import { useState, useEffect, useContext } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalContext } from '../ModalContext'

export default function ExerciseInstructionsModal() {
    const { modalData } = useContext(ModalContext)

    const [exerciseInstructions, setExerciseInstructions] = useState(null)

    const GetInstructionsFromBackend = async () => {
        const jsonBody = {
            exerciseId: modalData.exerciseId,
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('CORE', 'GET', '/exercise_instructions', jsonBody)

        // console.log(result.data.data);

        setExerciseInstructions(result.data.data)
    }

    useEffect(() => { GetInstructionsFromBackend() }, [])

    if (exerciseInstructions === null) {
        return (
            <div className='flex flex-col h-[80vh] overflow-y-auto'>
                <div className='space-y-4 p-4'>
                    <div className='w-full h-60 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                    <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                </div>
            </div>
        )
    }

    return (
        <div className='flex flex-col h-[80vh] space-y-4 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
            <h1>
                {exerciseInstructions.name}
            </h1>

            <video width="720" height="400" controls loop>
                <source src={exerciseInstructions.videoURL} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className='space-y-2'>
                {exerciseInstructions.textInstructions.split('\n').map((instruction, instructionIndex) => (
                    <p key={instructionIndex} className="text-left text-sm text-gray-600">
                        {instruction}
                    </p>
                ))}
            </div>
        </div>
    )
}
